import { AppFooter } from "@osakabe/auth-service-provider/shell";

const PROJECT_REPOSITORY_URL = "https://git.common.sereca.cloud/osakabe/refinement-canvas";

// po-board 同等のフッター。GitLab リポジトリへのアイコンリンクは画面左下固定とし、
// コピーライトはフッター中央に配置する。構造は共通シェルの AppFooter に委譲し、
// 既存のクラス名 (dashboard-footer 系) を className 注入して見た目を維持する。
export function DashboardFooter(): JSX.Element {
  return (
    <AppFooter
      classNames={{
        root: "dashboard-footer",
        link: "dashboard-footer__link",
        gitlabIcon: "dashboard-footer__gitlab-logo",
        srOnly: "visually-hidden",
        copyright: "dashboard-footer__copyright",
      }}
      copyright="©Takuro Osakabe ©MEIDENSHA"
      repositoryUrl={PROJECT_REPOSITORY_URL}
    />
  );
}
